const typography = {
  useNextVariants: true,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  h1: {
    fontSize: "2rem",
    fontWeight: 600
  },
  h2: {
    fontSize: "1.75rem",
    fontWeight: 600
  },
  h3: {
    fontSize: "1.5rem",
    fontWeight: 600
  },
  h4: {
    fontSize: "1.25rem",
    fontWeight: 600
  },
  h5: {
    fontSize: "1.125rem",
    fontWeight: 600
  },
  h6: {
    fontSize: "1rem",
    fontWeight: 600
  },
  button: {
    textTransform: "none"
  }
};

export default typography;
